var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 0.21051C5.48624 0.21051 0.210449 5.4863 0.210449 12C0.210449 18.5137 5.48624 23.7895 11.9999 23.7895C18.5136 23.7895 23.7894 18.5137 23.7894 12C23.7894 5.4863 18.5136 0.21051 11.9999 0.21051ZM10.8947 17.8947H5.73676C5.12519 17.8947 4.6315 17.401 4.6315 16.7895C4.6315 16.1779 5.12519 15.6842 5.73676 15.6842H10.8947C11.5062 15.6842 11.9999 16.1779 11.9999 16.7895C11.9999 17.401 11.5062 17.8947 10.8947 17.8947ZM15.3157 13.4737H5.73676C5.12519 13.4737 4.6315 12.98 4.6315 12.3684C4.6315 11.7568 5.12519 11.2631 5.73676 11.2631H15.3157C15.9273 11.2631 16.421 11.7568 16.421 12.3684C16.421 12.98 15.9273 13.4737 15.3157 13.4737ZM15.3157 9.05262H5.73676C5.12519 9.05262 4.6315 8.55893 4.6315 7.94735C4.6315 7.33577 5.12519 6.84209 5.73676 6.84209H15.3157C15.9273 6.84209 16.421 7.33577 16.421 7.94735C16.421 8.55893 15.9273 9.05262 15.3157 9.05262ZM18.2631 9.05262C17.6515 9.05262 17.1578 8.55893 17.1578 7.94735C17.1578 7.33577 17.6515 6.84209 18.2631 6.84209C18.8747 6.84209 19.3683 7.33577 19.3683 7.94735C19.3683 8.55893 18.8747 9.05262 18.2631 9.05262Z",
    fill: "#313136"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavClose);
export default __webpack_public_path__ + "static/media/nav_close.b7ed6feb534135631ebd8a2f444ba01b.svg";
export { ForwardRef as ReactComponent };